import React, { useState, useEffect } from 'react';
import LinkButton from './LinkButton';

const AudioStats = ({ onBack, backHref, onNavigateToLocation }) => {
    const [stats, setStats] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const response = await fetch('/api/quest-audio-stats', {
                    credentials: 'include'
                });
                if (!response.ok) {
                    if (response.status === 401) {
                        // This will be handled by the App component
                        return;
                    }
                    throw new Error('Failed to fetch audio stats');
                }
                const data = await response.json();
                setStats(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchStats();
    }, []);

    if (loading) {
        return <div className="loading">Loading audio stats...</div>;
    }

    if (error) {
        return <div className="error">Error: {error}</div>;
    }

    return (
        <div className="audio-stats-container">
            <div className="audio-stats-header">
                <h1>Quest Audio Statistics</h1>
                <LinkButton href={backHref} onClick={onBack} className="back-button">Back to Editor</LinkButton>
            </div>
            <p className="audio-stats-description">
                This table shows the audio coverage for the 'description' and 'after_message' fields for each quest. 
                Coverage is calculated as (fields with audio) / (fields with non-empty text).
            </p>
            <div className="table-responsive">
                <table className="audio-stats-table">
                    <thead>
                        <tr>
                            <th>Quest</th>
                            <th>Total Locations</th>
                            <th>Description Audio Coverage</th>
                            <th>After Message Audio Coverage</th>
                            <th>Locations Missing Description Audio</th>
                            <th>Locations Missing After Message Audio</th>
                        </tr>
                    </thead>
                    <tbody>
                        {stats.map(quest => (
                            <tr key={quest.quest_id}>
                                <td data-label="Quest"><strong>{quest.quest_name}</strong> <br/> <small>({quest.quest_id})</small></td>
                                <td data-label="Total Locations">{quest.total_locs}</td>
                                <td data-label="Description Audio Coverage">
                                    <span className={`coverage-pill ${quest.desc_audio_count < quest.desc_text_count ? 'partial' : 'full'}`}>
                                        {quest.desc_audio_count} / {quest.desc_text_count}
                                    </span>
                                </td>
                                <td data-label="After Message Audio Coverage">
                                    <span className={`coverage-pill ${quest.after_msg_audio_count < quest.after_msg_text_count ? 'partial' : 'full'}`}>
                                        {quest.after_msg_audio_count} / {quest.after_msg_text_count}
                                    </span>
                                </td>
                                <td data-label="Missing Description Audio">
                                    {quest.locations_missing_description_audio.length > 0
                                        ? (
                                            <ul className="missing-locations-list">
                                                {quest.locations_missing_description_audio.map((loc, index) => <li key={index}><button className="location-link" onClick={() => onNavigateToLocation(quest.quest_id, loc.id)}>{loc.name}</button></li>)}
                                            </ul>
                                        )
                                        : <span className="no-missing">None</span>
                                    }
                                </td>
                                <td data-label="Missing After Message Audio">
                                    {quest.locations_missing_after_message_audio.length > 0
                                        ? (
                                            <ul className="missing-locations-list">
                                                {quest.locations_missing_after_message_audio.map((loc, index) => <li key={index}><button className="location-link" onClick={() => onNavigateToLocation(quest.quest_id, loc.id)}>{loc.name}</button></li>)}
                                            </ul>
                                        )
                                        : <span className="no-missing">None</span>
                                    }
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AudioStats; 